import { createFileRoute } from '@tanstack/react-router';
import { redirectToDefaultTab } from '@/pages/workspaces/activity-logs/routing';

// Index → default tab (mirrors Ember `logs.index`).
export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/profile_activity/')({
  beforeLoad: ({ params }) => redirectToDefaultTab(params),
});
